export enum ELanguages {
  Fr = 'fr',
  Nl = 'nl',
}
